/**
 * A JSON value as a file part of a multipart request. Tomcat counts a part sent as plain text against its 2 MB
 * form data limit (maxPostSize) and rejects the whole request beyond it; a file part does not count, so any part
 * that can grow with the maquette (its elements, its codes) is sent this way.
 */
export function jsonFilePart(value: unknown): Blob {
  return new Blob([JSON.stringify(value)], { type: "application/json" })
}

export function streamToBlob(response: Response): Promise<Blob | undefined> {
  if (response?.body) {
    const reader = response.body.getReader()
    const stream = new ReadableStream({
      start(controller) {
        const pump = (): Promise<void> =>
          reader.read().then(({ done, value }) => {
            if (done) {
              controller.close()
              return
            }
            controller.enqueue(value)
            // eslint-disable-next-line consistent-return
            return pump()
          })
        return pump()
      },
    })
    const r = new Response(stream)
    return r.blob()
  }
  return Promise.resolve(undefined)
}
